import FeatureFlagsContext from './FeatureFlags.context'
import * as featureFlags from './featureFlags.constants'
export const FeatureFlagsProvider = FeatureFlagsContext.Provider
export const FeatureFlagsConsumer = FeatureFlagsContext.Consumer
export * from './useFeatureFlags'
export * from './useFeatureAvailable'
export * from './useFeatureFlagValue'
export { default as withFeatureFlags } from './withFeatureFlags'
export const FEATURE_FLAGS = featureFlags.FEATURE_FLAGS
